export type ChargeSelection = {
  charge1: boolean;
  charge2: boolean;
  charge3: boolean;
};

export type BucketSelection = {
  bucket1: number | null;
  bucket2: number | null;
  bucket3: number | null;
};

export type FormValues = {
  chargeType: "unlinked" | "fromRecipe";
  selectedBucketId: number | null;
  selectedRecipeId: number | null;
  selectedCharges: ChargeSelection;
  selectedBuckets: BucketSelection;
  selectedUnlinkedChargeNumber: number | null;
  scheduledHeat?: string;
};

export const DEFAULT_FORM_VALUES: FormValues = {
  chargeType: "fromRecipe",
  selectedBucketId: null,
  selectedRecipeId: null,
  selectedCharges: {
    charge1: true,
    charge2: true,
    charge3: true,
  },
  selectedBuckets: {
    bucket1: null,
    bucket2: null,
    bucket3: null,
  },
  selectedUnlinkedChargeNumber: null,
};

export const validateScheduledHeat = (
  value: string | undefined,
  formValues: FormValues,
) => {
  if (formValues.chargeType === "fromRecipe" && !value) {
    return "Scheduled heat is required";
  }
  if (value && !/^[A-Za-z]{2}\d{4}$/.test(value)) {
    return "Scheduled Heat must be 2 letters followed by 4 numbers (e.g. AB1234)";
  }
  return true;
};

export const validateBucket = (
  value: number | null,
  formValues: FormValues,
) => {
  if (formValues.chargeType === "unlinked" && !value) {
    return "Bucket is required";
  }
  return true;
};
